import React, { useEffect } from 'react';
import BlogsNews from '../component/blogs-news';
import OurServices from '../component/our-services';
import About from '../component/about';
import "../../node_modules/react-modal-video/css/modal-video.css";
import Wrapper from "../component/Wrapper";
import HomeTeam from "../component/homeTeam";
import HomeBanner from "../component/homeBanner";
import { useDispatch, useSelector } from "react-redux";
import { selectHomePageData } from "../store/selectors";
import { getHomePageData } from "../store/actions/app";
import Error404 from "../component/404";
import Preloader from "../component/Preloader";

export default function Index() {
    const dispatch = useDispatch();
    const homePageData = useSelector(selectHomePageData);
    const status = useSelector(state => state.app.status.homePageData);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(getHomePageData());
        }
    }, [dispatch, status]);

    if (status === 'loading' || status === 'idle') {
        return (
           <Preloader/>
        );
    }

    if (status === 'failed' || !homePageData) {
        return <Error404 />;
    }

    return (
        <Wrapper>
            <HomeBanner homePageData={homePageData} />
            <About homePageData={homePageData} />
            <OurServices homePageData={homePageData} />
            <BlogsNews homePageData={homePageData} />
            <HomeTeam homePageData={homePageData} />
        </Wrapper>
    );
}
